module.exports = __webpack_public_path__ + "assets/img/icon_video.68355504.svg";